<script>
  import { pipe, values, filter, length } from "ramda";
  import { onMount } from "svelte";
  import { acceptLegalTerms } from "./store";
  import Checkbox from "common/components/Checkbox";

  export let legalTerms = [];
  export let url = "";
  export let strings = {};

  let accepted = {};

  $: valid =
    legalTerms.length === pipe(values, filter(Boolean), length)(accepted);

  $: $acceptLegalTerms = valid;

  $: {
    if (valid === true) {
      console.log("All legal terms are accepted");
      // $acceptLegalTerms = true;
    } else {
      // $acceptLegalTerms = false;
      console.log("Legal terms are not accepted");
    }
  }

  onMount(() => {
    legalTerms.forEach((item) => {
      accepted[item.id] = accepted.hasOwnProperty(item.id)
        ? accepted[item.id]
        : false;
    });
  });

  function legalTermUrl(id) {
    return url.replace("__PLACEHOLDER__", id);
  }

  function legalTermLink({ id, title }) {
    return `<a href=${legalTermUrl(id)} target="_blank">${title}</a>`;
  }

  function legalTermTitle(legalTerm) {
    let string =
      legalTerm.organizer_id === null
        ? strings.accept_ticketcos
        : strings.accept_organizers;
    return string.replace("__LINK__", legalTermLink(legalTerm));
  }
</script>

<style>
  .legal-terms-container {
    text-align: left;
    display: inline-block;
    vertical-align: middle;
  }
  .legal-terms--item-label {
    text-transform: none;
    color: #333;
    color: var(--main-card-foreground-color, #333);
  }
</style>

{#if legalTerms.length > 0}
  <div class="legal-terms-container">
    {#each legalTerms as legalTerm, index (legalTerm.id)}
      <div class="t-form-row">
        <label class="t-label-small" for="check_legal_terms_buyer_{index}">
          <Checkbox
            id="check_legal_terms_buyer_{index}"
            name="legal_terms[{legalTerm.id}]"
            value={accepted[legalTerm.id]}
            class="flex-none __size-big __shake t-ml-0"
            on:change={({ detail }) => (accepted[legalTerm.id] = detail)} />
          <span class="legal-terms--item-label relative pr-2 flex-1">
            {#if legalTerm.display_as}
              <a href={legalTermUrl(legalTerm.id)} target="_blank">
                {legalTerm.display_as}
              </a>
            {:else}
              {@html legalTermTitle(legalTerm)}
            {/if}
            <span class="absolute top-0 right-0 font-medium text-red-500"
              >*</span>
          </span>
        </label>
      </div>
    {/each}
  </div>
{/if}
